import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useAuth } from '../../hooks/useAuth';

const PointsContext = createContext();

export const PointsProvider = ({ children }) => {
  const { user } = useAuth();
  const [points, setPoints] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchPoints = useCallback(async () => {
    if (!user?.email) {
      setPoints(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(false);
    try {
      const userRef = doc(db, 'users', user.email);
      const userSnap = await getDoc(userRef);
      let pts = 0;
      if (userSnap.exists()) {
        const data = userSnap.data();
        pts = typeof data.points === 'number' ? data.points : parseInt(data.points) || 0;
      }
      setPoints(pts);
    } catch (err) {
      setPoints(0);
      setError(true);
    }
    setLoading(false);
  }, [user]);

  useEffect(() => {
    fetchPoints();
  }, [fetchPoints]);

  return (
    <PointsContext.Provider value={{ points, loading, error, refreshPoints: fetchPoints, setPoints }}>
      {children}
    </PointsContext.Provider>
  );
};

export const usePoints = () => useContext(PointsContext); 